import { createOperationsGenerator, defineProvider } from '@nuxt/image/runtime'
import { encodeQueryItem, joinURL } from 'ufo'

const operationsGenerator = createOperationsGenerator({
  keyMap: {
    width: 'width',
    height: 'height',
    format: 'format',
  },
  joinWith: '&',
  formatter: (key, value) => encodeQueryItem(key, value),
})

export default defineProvider({
  getImage(src, { modifiers }) {
    const operations = operationsGenerator(modifiers)

    return {
      url: joinURL(src + (operations ? '?' + operations : '')),
    }
  },
})
